export function thousandAndMillionFormatter(value) {
  if (value === 0) {
    return value
  }

  if (value % 1000000 === 0) {
    return `${value / 1000000}M`
  }

  if (value % 1000 === 0) {
    return `${value / 1000}K`
  }

  return value
}

export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0
})
